import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { GlobalMethodsService } from '../../../../../../services/global-methods.service';
import { BillService } from '../../../../../../services/commons/bill.service';
import { TranslateService } from '@ngx-translate/core';
import { GlobalVariablesService } from '../../../../../../services/global-variables.service';
import { StorageService } from '../../../../../../services/commons/storage.service';
import * as Base64ArrayBuffer from 'base64-arraybuffer'
import { FirebaseCrashlytics } from '@capacitor-community/firebase-crashlytics';
import { ModalService } from '../../../../../../services/commons/modal.service';
import { registerPlugin } from "@capacitor/core";
import { FileSharer } from '@byteowls/capacitor-filesharer';
import * as moment from 'moment';
const AppRatePlugin = registerPlugin<any>('AppRatePlugin');
const DEFAULT_ZOOM = 1;
@Component({
  selector: 'app-bill-detail',
  templateUrl: './bill-detail.component.html',
  styleUrls: ['./bill-detail.component.scss'],
})
export class BillDetailComponent implements OnInit {

  public user: any;
  public pdf: any;
  public base64Bill: string;
  public pdfZoom = DEFAULT_ZOOM;
  @Input('invoice') invoice: string;
  @Input('invoiceDate') invoiceDate: string;
  @ViewChild('pdfViewer') pdfViewer: ElementRef;

  constructor(
    private modalCtrl: ModalController,
    public gms: GlobalMethodsService,
    private billService: BillService,
    private translate: TranslateService,
    private gvs: GlobalVariablesService,
    private storage: StorageService,
    public modalService: ModalService,
    public platform: Platform
  ) { }

  ngOnInit() { }

  async ionViewWillEnter() {
    try {
      this.gms.analyticsTrackEvent('openScreen', {screenName: 'Detalle Factura', contentGroup: 'Facturas'}); 
      await this.gms.clearIntervalStatusInstallationEvent();
      this.user = this.gvs.user;
      this.base64Bill = await this.billService.gAppuserViewInvoice(this.user.userName, this.invoice);
      if (this.base64Bill === undefined){
        await this.gms.openGenericModal(await this.translate.instant('MODAL.titleError'), await this.translate.instant('MESSAGES.downloadBillKo'),
          'modal-default', await this.translate.instant('BUTTON.agreed'));
        return;
      }
      if (this.base64Bill !== '') {
        this.pdf = new Uint8Array(Base64ArrayBuffer.decode(this.base64Bill));
      }
      if (this.pdf == null) {
        await this.gms.openGenericModal(await this.translate.instant('MODAL.titleError'), await this.translate.instant('MESSAGES.downloadBillKo'),
          'modal-default', await this.translate.instant('BUTTON.agreed'));
      }
    } catch (e) {
      const message = JSON.stringify(e);
      await FirebaseCrashlytics.recordException({message: message});
      setTimeout(async () => { this.modalCtrl.dismiss(false, '', 'loadingModal'); }, 1000);
      await this.gms.openGenericModal(await this.translate.instant('MODAL.titleError'), await this.translate.instant('MESSAGES.downloadBillKo'),
          'modal-default', await this.translate.instant('BUTTON.agreed'));
    }
  }

  dismiss(result: boolean) {
    // this.modalCtrl.dismiss({ result: result });
    this.modalCtrl.dismiss("billDetailModal");
  }

  async downloadBill() {
    this.gms.analyticsTrackEvent('invoice_action', {eventCategory: 'SICOR/Descarga Factura', eventAction: 'Accion/Descarga Factura Inicio', eventLabel: moment(this.invoiceDate).format('MM/YY') });
    let contentType = 'application/pdf';
    let format = '.pdf';
    let invDate = this.invoiceDate.split('/');
    let formattedDate = '';
    invDate.forEach(fragment => {
      if (formattedDate === ''){
        formattedDate = fragment;
      }else{
        formattedDate = formattedDate + '-' + fragment;
      }
    });
    let base64Data = this.base64Bill;
    FileSharer.share({
      filename: 'FacturaSICOR-' + formattedDate + format,
      base64Data: base64Data,
      contentType: contentType
    })
    if (!this.platform.is("desktop") && !this.platform.is("mobileweb") && this.gvs.ratingAvailable) {
      AppRatePlugin.customRatingCall();
      this.gvs.ratingAvailable = false;
    }
    // const checkInternet = await this.gms.checkInternet();
    // if (checkInternet) {
    //   const response = await this.billService.gAppuserInvoiceDwl(this.user.userName, this.invoice);
    //   if (response != null) {
    //     this.gms.analyticsTrackEvent('invoice_action', {eventCategory: 'SICOR/Descarga Factura', eventAction: 'Accion/Descarga Factura OK', eventLabel: moment(this.invoiceDate).format('MM/YY') });
    //     await this.gms.openGenericModal(await this.translate.instant('MODAL.titleInfo'), response,
    //       'modal-default', await this.translate.instant('BUTTON.agreed'));
    //       if(!this.platform.is("desktop") && !this.platform.is("mobileweb") && this.gvs.ratingAvailable){
    //         AppRatePlugin.customRatingCall();
    //         this.gvs.ratingAvailable = false;
    //       }
    //   } else if (response != undefined) {
    //     this.gms.analyticsTrackEvent('invoice_action', {eventCategory: 'SICOR/Descarga Factura', eventAction: 'Error/Download Invoice', eventLabel: moment(this.invoiceDate).format('MM/YY') });
    //     await this.gms.openGenericModal(await this.translate.instant('MODAL.titleError'), await this.translate.instant('MESSAGES.downloadBillKo'),
    //       'modal-default', await this.translate.instant('BUTTON.agreed'));
    //   }else{
    //     this.gms.analyticsTrackEvent('invoice_action', {eventCategory: 'SICOR/Descarga Factura', eventAction: 'Error/Download Invoice', eventLabel: moment(this.invoiceDate).format('MM/YY')});
    //   }
    // } else {
    //   await this.gms.openGenericModal(await this.translate.instant('MODAL.titleError'), await this.translate.instant('MESSAGES.noInternetConnection'),
    //     'modal-default', await this.translate.instant('BUTTON.agreed'));
    // }
  }

}
